export default "__VITE_ASSET__Dm9lcPAY__"